<template>
  <div class="proxy-messages-page">
    <ForwardingTable />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ForwardingTable from '@/views/Staff/Proxy/Forwarding/Table.vue'

export default defineComponent({
  name: 'ServicePointForwardingHubPage',
  components: { ForwardingTable },
})
</script>
